'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = TextInputLabel;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function TextInputLabel(_ref) {
	var inputId = _ref.inputId,
	    value = _ref.value,
	    required = _ref.required,
	    invalid = _ref.invalid,
	    floats = _ref.floats,
	    children = _ref.children,
	    rest = _objectWithoutProperties(_ref, ['inputId', 'value', 'required', 'invalid', 'floats', 'children']);

	return _react2.default.createElement(
		'label',
		_extends({}, rest, {
			htmlFor: inputId,
			className: (0, _classnames2.default)('rrui__input-label', {
				'rrui__input-label--required': required && isEmptyOrBlank(value),
				'rrui__input-label--required-field': required,
				'rrui__input-label--invalid': invalid,
				'rrui__input-label--floating': floats,
				'rrui__text-input__label--placeholder': floats && isEmptyOrBlank(value)
			}) }),
		children
	);
}

function isEmptyOrBlank(value) {
	// Whitespace strings are considered empty.
	if (typeof value === 'string') {
		return !value || !value.trim();
	}
	return value === undefined || value === null;
}
//# sourceMappingURL=TextInputLabel.js.map